import { useState } from "react";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AllyLeadCard = ({ sid, page, onDone }) => {
  const [f, setF] = useState({ name: "", email: "", firm: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const res = await fetch(`${API}/chat/${sid}/lead`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ...f, page }) });
      if (!res.ok) throw new Error(res.status === 422 ? "Please enter a valid work email." : "Something went wrong. Please try again.");
      onDone(f.name.split(" ")[0]);
    } catch (x) { setErr(x.message); } finally { setBusy(false); }
  };

  const field = "w-full bg-white border border-black/10 rounded-xl px-3 py-2 text-sm outline-none focus:border-ally-pink transition-colors";
  return (
    <form onSubmit={submit} data-testid="public-ally-lead-form" className="bg-white border border-ally-soft rounded-2xl p-4 space-y-2 shadow-sm">
      <div className="text-sm font-semibold text-ally-ink">Happy to keep going.</div>
      <div className="text-xs text-ally-slate pb-1">Who am I chatting with? We'll only use this to follow up.</div>
      <input required placeholder="Your name" value={f.name} onChange={set("name")} className={field} data-testid="public-ally-lead-name" />
      <input required type="email" placeholder="Work email" value={f.email} onChange={set("email")} className={field} data-testid="public-ally-lead-email" />
      <input required placeholder="Firm name" value={f.firm} onChange={set("firm")} className={field} data-testid="public-ally-lead-firm" />
      {err && <div className="text-xs text-red-600" data-testid="public-ally-lead-error">{err}</div>}
      <button type="submit" disabled={busy} data-testid="public-ally-lead-submit"
        className="w-full bg-ally-pink text-white text-sm font-semibold rounded-full py-2.5 hover:bg-ally-ink transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
        {busy && <Loader2 size={14} className="animate-spin" />} Continue chatting
      </button>
    </form>
  );
};
